// extracted by mini-css-extract-plugin
export var addProductButton = "add-shopping-list-module--add-product-button--b0f15";
export var description = "add-shopping-list-module--description--11b4c";
export var form = "add-shopping-list-module--form--272de";
export var globalErrors = "add-shopping-list-module--global-errors--68137";
export var header = "add-shopping-list-module--header--bd35b";
export var input = "add-shopping-list-module--input--6f903";
export var loading = "add-shopping-list-module--loading--20f3f";
export var products = "add-shopping-list-module--products--3560d";
export var separator = "add-shopping-list-module--separator--0fbcc";
export var successBox = "add-shopping-list-module--success-box--3b248";
export var successButtons = "add-shopping-list-module--success-buttons--a635d";
export var successContent = "add-shopping-list-module--success-content--72728";
export var title = "add-shopping-list-module--title--f680e";